import { doc, writeBatch } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import { PRODUCTS, PLANS, COURSES } from '../constants/entities';

const COLLECTION_BY_TYPE = {
  product: PRODUCTS,
  plan: PLANS,
  course: COURSES,
};

/** Persiste a ordem global dos representantes da vitrine (campo `order` em cada doc). */
export async function persistCatalogVitrineOrder(orderedItems = []) {
  const batch = writeBatch(firestore);
  orderedItems.forEach((item, index) => {
    const collectionName = COLLECTION_BY_TYPE[item.type];
    if (!collectionName || !item?.id) return;
    batch.update(doc(firestore, collectionName, item.id), { order: index });
  });
  await batch.commit();
}
